// Language catalogs shared by the web UI, API and worker.
//
// Two DIFFERENT lists on purpose:
//  - SOURCE_LANGUAGES: what a video's audio can be transcribed FROM. Each maps to
//    a real Google Speech-to-Text BCP-47 code, because STT needs a concrete
//    primary language (there is no reliable "detect any of 12" mode). Only codes
//    Google actually supports belong here.
//  - TRANSLATE_LANGUAGES: what the transcript can be translated TO. This is an
//    AI (LLM) step, not STT, so it can offer anything — including "Roman Hindi"
//    (Hindi in Latin script) and "Taiwanese", which have no STT source code.
/** Transcription source languages (Google STT). "Hinglish" shares hi-IN with
 *  Hindi — the provider already adds English alternates for code-switching. */
export const SOURCE_LANGUAGES = [
    { label: 'English', code: 'en-US' },
    { label: 'Hindi', code: 'hi-IN' },
    { label: 'Hinglish', code: 'hi-IN' },
    { label: 'Spanish', code: 'es-ES' },
    { label: 'French', code: 'fr-FR' },
    { label: 'German', code: 'de-DE' },
    { label: 'Portuguese', code: 'pt-BR' },
    { label: 'Arabic', code: 'ar-SA' },
    { label: 'Indonesian', code: 'id-ID' },
    { label: 'Traditional Chinese', code: 'cmn-Hant-TW' },
];
/** "Detect automatically" pseudo-option. Not a real STT code — the worker
 *  resolves `auto` to a concrete language via local detection (faster-whisper)
 *  before transcribing. */
export const AUTO_LANGUAGE = { label: 'Auto (detect)', code: 'auto' };
/** Auto first, then the concrete source languages — for language pickers. */
export const SOURCE_LANGUAGE_OPTIONS = [AUTO_LANGUAGE, ...SOURCE_LANGUAGES];
/** The set of valid source codes, for API validation. */
export const SOURCE_LANGUAGE_CODES = Array.from(new Set(SOURCE_LANGUAGES.map((l) => l.code)));
/** Translation targets (AI). Superset of the source labels plus text-only ones
 *  (Roman Hindi, Taiwanese) that have no Google STT source code. */
export const TRANSLATE_LANGUAGES = [
    'English',
    'Hindi',
    'Hinglish',
    'Roman Hindi',
    'Spanish',
    'French',
    'German',
    'Portuguese',
    'Arabic',
    'Indonesian',
    'Traditional Chinese',
    'Taiwanese',
];
//# sourceMappingURL=languages.js.map